import { render, staticRenderFns } from "./resdExam.vue?vue&type=template&id=5b8ca035&scoped=true"
import script from "./resdExam.vue?vue&type=script&lang=js"
export * from "./resdExam.vue?vue&type=script&lang=js"
import style0 from "./resdExam.vue?vue&type=style&index=0&id=5b8ca035&prod&lang=scss"
import style1 from "./resdExam.vue?vue&type=style&index=1&id=5b8ca035&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8ca035",
  null
  
)

export default component.exports